$(function(){

    $('.my-library--shelf').each(function(index, element){
        var $shelf = $(element),
            $showMore = $('.my-library--shelf-show-more', $shelf),
            $list = $('.profile-book-list', $shelf);

        $list.data('fullHeight', $list.height());
        $list.data('hidden', true);
        $list.css({height: '302px'});

        $('.book-list--item', $list).each(function(item_indx, item_elemnt){
            if (item_indx >= 8)
                $(item_elemnt).addClass('_cut').hide();
            if (item_indx >= 4)
                $(item_elemnt).parent().css({height: '670px'});
        });

        $showMore.on('click', function(){
            if ($list.data('hidden') === true) {
                $('.book-list--item._cut', $list).show();

                $list.css({overflow: 'hidden'})
                    .animate({height: $list.data('fullHeight') + 'px'}, 400, function(){
                        $list.css({overflow: 'visible'});
                        $list.removeAttr('style');
                        $list.data('hidden', false);
                    });
                $showMore.addClass('_hide');
            }
            else {
                $list.css({overflow: 'hidden'})
                    .animate({height: '670px'}, 300, function(){
                        $('.book-list--item._cut', $list).hide();
                        $list.css({overflow: 'visible'});
                        $list.data('hidden', true);
                    });
                $showMore.removeClass('_hide');
            }

            return false;
        });
    });

});
